module.exports = __webpack_public_path__ + "static/media/12.6cbdb683.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/12.jpg
// module id = 381
// module chunks = 0